import { render, staticRenderFns } from "./DoctorsPending.vue?vue&type=template&id=3f6811d3&scoped=true&"
import script from "./DoctorsPending.vue?vue&type=script&lang=js&"
export * from "./DoctorsPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6811d3",
  null
  
)

export default component.exports